import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import List from '@mui/material/List';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import { useSelector } from 'react-redux';

import { validateShopPermissions } from 'modules/shop/shared/parsers';

import {
  creditAnalysis,
  riskSolutions,
  analyticalOperations,
  generalServices,
  subscriptionsServices,
  eventsServices,
  scopeExplorer,
  admin,
} from 'shared/constants/menuItems';

import MenuModule from './MenuModule/MenuModule';

const useStyles = makeStyles(theme => ({
  creditAnalysis: {
    textTransform: 'uppercase',
  },
  menuButton: {
    marginRight: theme.spacing(1),
  },
  listWrapper: {
    width: 340,
    padding: 0,
  },
}));

const Menu = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [toggle, setToggle] = useState(false);
  const {
    data: { shopPermissions },
  } = useSelector(state => state.auth);

  const handleClick = () => setToggle(!toggle);
  const closeMenu = () => setToggle(false);
  const canAccessByShopPermissions = menu =>
    !menu.shopPermissions || validateShopPermissions(shopPermissions, menu.shopPermissions);

  const filterOutEmpty = menu => menu.subnavigation.filter(menuItem => !menuItem.hidden).length;

  const menus = [
    creditAnalysis,
    riskSolutions,
    analyticalOperations,
    generalServices,
    subscriptionsServices,
    eventsServices,
    scopeExplorer,
    admin,
  ];

  return <>
    <IconButton
      onClick={handleClick}
      className={classes.menuButton}
      color="inherit"
      edge="start"
      size="large">
      <MenuIcon />
    </IconButton>
    <Typography className={classes.creditAnalysis} variant="h6" component="h2" color="inherit">
      {t('Finance intelligence')}
    </Typography>
    <Drawer anchor="left" open={toggle} onClose={handleClick}>
      <List
        component="nav"
        aria-labelledby="navbar-list-subheader"
        className={classes.listWrapper}
      >
        {menus
          .filter(canAccessByShopPermissions)
          .filter(filterOutEmpty)
          .map(menu => (
            <MenuModule key={menu.label} closeMenu={closeMenu} module={menu} />
          ))}
      </List>
    </Drawer>
  </>;
};

export default Menu;
